import { useEffect, useCallback, useMemo } from 'react';
import { useStateIfMounted } from 'use-state-if-mounted';

const cleanHtml = body => {
  if (!body) return body;
  // Replace break tags with newlines
  const content = body.replace(/<br\s*\/?>/g, '\r\n');

  const span = document.createElement('span');
  span.innerHTML = content;

  return span.textContent || span.innerText;
};

export const useMessageContent = ({ message }) => {
  const [imageSrc, setImageSrc] = useStateIfMounted(null);
  const [imageFileType, setImageFileType] = useStateIfMounted(null);

  const getMedia = useCallback(async () => {
    const mediaUrl = await message.media.getContentTemporaryUrl();
    setImageFileType(message.media.contentType);
    setImageSrc(mediaUrl);
  }, [message]);

  useEffect(() => {
    if (message.media) getMedia();
  }, [message]);

  const cleanBody = useMemo(() => cleanHtml(message.body), [message]);

  const textWithHyperlinks = useMemo(() => {
    const body = cleanHtml(message.body);
    if (!body) return null;

    /**
     * Placing parens around a RegExp leaves the token in the split
     * tokenized array, so that consuming components can just check
     * if the token begins with a protocol and conditionally render an
     * anchor tag, rather than dangerously setting innerHTML.
     */
    const tokens = body.split(/(https?:\/\/\S*)/);

    /**
     * If no hyperlinks were detected, return null to indicate that
     * the message body should be rendered as plain text.
     */
    if (tokens.length === 1) return null;

    return tokens;
  }, [message]);

  return {
    cleanBody,
    imageSrc,
    imageFileType,
    textWithHyperlinks
  };
};
